/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react'
import type { FlexProps } from '@vtex/admin-ui'
import { color, csx, cx } from '@vtex/admin-ui'

export type SalesAssociateCardProps = FlexProps

export const SalesAssociateCard = ({
  className = '',
  ...props
}: SalesAssociateCardProps) => (
  <div
    className={cx(
      csx({
        paddingY: '$space-5',
        paddingX: '$space-5',
        border: '$neutral',
        borderRadius: '0.3rem',
        color: color('$blue40'),
        justifyContent: 'space-between',
        alignItems: 'center',
        cursor: 'pointer',
        display: 'flex',
      }),
      className
    )}
    onClick={props.onClick}
  >
    {props.children}
  </div>
)
